import { CollabItem, CollabItemType } from 'stores/DocStore.types'
import { TrackedChangeItemSummary } from 'components/CollabItemInlineWidget/TrackedChangeItemSummary'
import { DefaultItemSummary } from 'components/CollabItemInlineWidget/DefaultItemSummary'
import { CommentItemSummary } from 'components/CollabItemInlineWidget/CommentItemSummary'

interface Props {
  collabItem: CollabItem
  isActive: boolean
}

export const CollabItemSummary = ({ collabItem, isActive }: Props) => {
  switch (collabItem.type) {
    case CollabItemType.TrackedChange:
      return <TrackedChangeItemSummary collabItem={collabItem} isActive={isActive} />
    case CollabItemType.Comment:
      return <CommentItemSummary collabItem={collabItem} isActive={isActive} />
    default:
      return <DefaultItemSummary isActive={isActive} />
  }
}
